<div *ngIf="isDisplayed" class="production-tracking-container">
    <div class="step-container" *ngIf="product?.gok">
        <div class="tooltip-container">
            <div class="step">
                <img src="assets/images/GreenOk.png" alt="GreenOk">
            </div>
            <span class="step-name">Green OK</span>
            <div class="tooltip-content">
                <span class="tooltip-text">{{product!.gok | demoDate}}</span>
            </div>
        </div>
    </div>
    
    <div class="step-container" *ngIf="product?.leftGate">
        <div class="between-step" *ngIf="product?.gok"></div>
        <div class="tooltip-container">
            <div class="step">
                <img src="assets/images/LeftGate.png" alt="LeftGate">
            </div>
            <span class="step-name">Left Gate</span>
            <div class="tooltip-content">
                <span class="tooltip-text">{{product!.leftGate | demoDate}}</span>
            </div>
        </div>
    </div>
</div>